import React, { useState } from "react";
import { Box } from "@mui/material";
import HeroArt from "./HeroArt";

// Shows the hero artwork if the file has been added, and falls back to the
// built-in SVG scene if it is missing — so the page never renders a broken
// image while the asset is being prepared.
const HERO_IMAGE = "/assets/images/hero.jpg";

const HeroVisual = () => {
  const [failed, setFailed] = useState(false);

  if (failed) return <HeroArt />;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "660px",
        position: "relative",
        // the artwork is dark-edged, so it blends into the band instead of
        // sitting on it as a hard rectangle
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          borderRadius: "22px",
          boxShadow: "inset 0 0 60px 20px rgba(11,18,32,.55)",
        },
      }}
    >
      <Box
        component="img"
        src={HERO_IMAGE}
        alt=""
        onError={() => setFailed(true)}
        fetchpriority="high"
        decoding="async"
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
          borderRadius: "22px",
          border: "1px solid rgba(255,255,255,.10)",
          boxShadow: "0 30px 70px rgba(2,6,23,.55)",
        }}
      />
    </Box>
  );
};

export default HeroVisual;
